import { useEffect } from 'react';
import OktaAuth from '@okta/okta-auth-js';

declare var google: any;

// const oktaAuth = new OktaAuth({
//   issuer: process.env.REACT_APP_OKTA_GOOGLE_ISSUER,
//   clientId: process.env.REACT_APP_OKTA_GOOGLE_CLIENT_ID,
//   redirectUri: process.env.REACT_APP_OKTA_GOOGLE_REDIRECT_URI,
// });

const GoogleOktaSSO = () => {
  useEffect(() => {
    const zbGOneTapValue = typeof window !== 'undefined' ? localStorage?.getItem('zbGOneTap') : undefined;
    const zbOne = zbGOneTapValue ? JSON.parse(zbGOneTapValue) : undefined;
    if (!zbOne || true) return null;

    let scriptsLoaded = {
      google: false,
      okta: false,
    };

    const checkAllScriptsReady = () => {
      if (scriptsLoaded.google && scriptsLoaded.okta) {
        const initializeAuth = async () => {
          const oktaAuth = new OktaAuth({
            issuer: 'https://okta.zerobounce.xyz/oauth2/default',
            clientId: '0oa2mssgi6TmVaZil697',
            redirectUri: 'https://www.zerobounce.xyz/members/login/callback',
            pkce: true,
            scopes: ['openid', 'profile', 'email', 'offline_access'],
          });
          const isAuth = await oktaAuth.isAuthenticated();
          if (!isAuth) {
            google.accounts.id.initialize({
              client_id: '34024285727-a9mjktjkr0h4mckd5jmr45krbko0knnc.apps.googleusercontent.com',
              itp_support: true,
              use_fedcm_for_prompt: true,
              callback: async (response) => {
                let email = undefined;
                try {
                  const jwt = response.credential;
                  const payload = JSON.parse(atob(jwt.split('.')[1]));
                  email = payload.email;
                } catch (e) {
                  console.log(e);
                }

                try {
                  oktaAuth.transactionManager.clear();
                  const currentTransaction = await oktaAuth.idx.startTransaction({
                    flow: 'default',
                  });
                  oktaAuth.idx.proceed({ step: 'identify', identifier: email });
                  // @ts-ignore
                  const stepHref = currentTransaction?.availableSteps?.find((s) => s.name === 'redirect-idp' && s.type === 'GOOGLE')?.href;
                  if (stepHref) {
                    window.location.href = `${stepHref}`;
                  } else {
                    window.location.href = `https://okta.zerobounce.xyz/sso/idps/0oa2msx8gq6fnEalh697?stateToken=${currentTransaction?.context?.stateHandle}`;
                  }
                } catch (e) {
                  console.log(e);
                }
              },
            });
            google.accounts.id.prompt();
          } else {
            console.log('User is already authenticated');
          }
        };
        initializeAuth();
      }
    };

    const googleScript = document.createElement('script');
    googleScript.src = 'https://accounts.google.com/gsi/client';
    googleScript.async = true;
    googleScript.defer = true;
    googleScript.onload = () => {
      scriptsLoaded.google = true;
      checkAllScriptsReady();
    };
    document.body.appendChild(googleScript);

    const oktaScript = document.createElement('script');
    oktaScript.src = 'https://global.oktacdn.com/okta-auth-js/7.12.1/okta-auth-js.min.js';
    oktaScript.type = 'text/javascript';
    oktaScript.integrity = 'sha384-6epSwnIDkI5zFNEVNjEYy3A7aSZ+C7ehmEyG8zDJZfP9Bmnxc51TK8du+2me4pjb';
    oktaScript.crossOrigin = 'anonymous';
    oktaScript.onload = () => {
      scriptsLoaded.okta = true;
      checkAllScriptsReady();
    };
    document.body.appendChild(oktaScript);

    return () => {
      document.body.removeChild(googleScript);
      document.body.removeChild(oktaScript);
    };
  }, []);

  return null;
};

export default GoogleOktaSSO;
